import { render, staticRenderFns } from "./master_details_grids.vue?vue&type=template&id=fbd8d672"
import script from "./master_details_grids.ts?vue&type=script&lang=js&external"
export * from "./master_details_grids.ts?vue&type=script&lang=js&external"
import style0 from "./master_details_grids.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports